import React, { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { useAuthContext } from "../../../AuthContextWrapper";
import { SingleTextForm } from "../shared/SingleTextForm";
import { OUTCOMES } from "../../../constants";
import { Outcomes } from "./PropertyTitleTypeScreen";
import { AssetContext } from "../../../AssetContextWrapper";
import { AssetRealEstate } from "../../../models/AssetDetail";
import { estateApi } from "../../../apis";

export const PropertyTitleScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { flow, activeEstate, user } = useAuthContext()
  const { assetsLoaded } = useContext(AssetContext);
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);
  const primaryRealEstate = activeEstate?.primaryRealEstate;
  const reAsset = primaryRealEstate?.detail as AssetRealEstate;

  useEffect(() => {
    if (assetsLoaded && !activeEstate?.primaryRealEstate) {
      currentScreen &&
        flow?.navigateToNext(currentScreen, Outcomes.skip, navigate, {
          replace: true,
        });
    }
  }, [assetsLoaded]);

  const handleComplete = async (title: string): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    if (activeEstate?.id && user?.id && activeEstate?.primaryRealEstate?.detail && title) {
      (activeEstate.primaryRealEstate.detail as AssetRealEstate).title = title;
      try {
        await estateApi.saveAsset(primaryRealEstate,activeEstate.id, user.id);
      } catch (error) {
        throw new Error("could not save data");
      }
    }

    flow?.navigateToNext(currentScreen, OUTCOMES.complete, navigate);
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper title="What is the exact titling, if you know it?">
      <>
        <SingleTextForm
          initText={reAsset?.title?.toString()}
          errorText="Please enter the exact title or let us know if you're not sure"
          textLabel="Enter exactly as is on Title"
          onComplete={handleComplete}
          onBack={() => navigate(-1)}
          noneTextOption="I’m not sure"
        />
      </>
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
